import { ElementTypes } from "../../../../domain/editableFormat/objects";
import { IObjectTranslatable } from "./IObjectTranslatable";
import {
  NotImplementedObjectTranslator,
  LineObjectTranslator,
  PositionCorrectionObjectTranslator,
  StampObjectTranslator,
  BoxLineObjectTranslator,
  CircleObjectTranslator,
  BarcodeObjectTranslator,
  TextObjectTranslator,
  DateObjectTranslator,
  TagObjectTranslator,
  ScriptLinkObjectTranslator,
  ScriptObjectTranslator,
  CalculateObjectTranslator,
  JoinTextObjectTranslator,
  CheckObjectTranslator,
  CircleSelectObjectTranslator,
  ComboObjectTranslator,
  RollObjectTranslator,
  ImageAreaObjectTranslator,
  ImageObjectTranslator,
  GraphObjectTranslator,
} from "./objects";

export class ObjectTranslatorRepository {
  private _notImplementedObjectTranslator: NotImplementedObjectTranslator = new NotImplementedObjectTranslator();
  private _translators: { [key in ElementTypes]: IObjectTranslatable; } = {
    text: new TextObjectTranslator(),
    date: new DateObjectTranslator(),
    tag: new TagObjectTranslator(),
    script: new ScriptObjectTranslator(),
    scriptlink: new ScriptLinkObjectTranslator(),
    calculate: new CalculateObjectTranslator(),
    jointext: new JoinTextObjectTranslator(),
    check: new CheckObjectTranslator(),
    circleselect: new CircleSelectObjectTranslator(),
    combo: new ComboObjectTranslator(),
    roll: new RollObjectTranslator(),
    imagearea: new ImageAreaObjectTranslator(),
    image: new ImageObjectTranslator(),
    stamp: new StampObjectTranslator(),
    graph: new GraphObjectTranslator(),
    embed: this._notImplementedObjectTranslator,          // Claioシェーマ使わないので優先度は低.
    sign: this._notImplementedObjectTranslator,           // Docu2Web未実装.E大でも使わないので優先度は低.
    barcode: new BarcodeObjectTranslator(),
    poscorrect: new PositionCorrectionObjectTranslator(),
    richText: this._notImplementedObjectTranslator,       // E大に出荷してるファイル版にはないので優先度は低.
    newPage: this._notImplementedObjectTranslator,        // E大に出荷してるファイル版にはないので優先度は低.
    watermark: this._notImplementedObjectTranslator,      // DMO用なので優先度は低.
    variablearea: this._notImplementedObjectTranslator,   // DMO用なので優先度は低.
    line: new LineObjectTranslator(),
    boxline: new BoxLineObjectTranslator(),
    circle: new CircleObjectTranslator(),
    triangle: this._notImplementedObjectTranslator,       // 最新版でもフォーマット編集には機能なし.優先度低.
    cross: this._notImplementedObjectTranslator,          // 最新版でもフォーマット編集には機能なし.優先度低.
  };

  getTranslator(elementName: string): IObjectTranslatable {
    if (!elementName) {
      console.warn("empty element type");
      return this._notImplementedObjectTranslator;
    }
    if (!(elementName in this._translators)) {
      console.warn("unknown element type: " + elementName);
      return this._notImplementedObjectTranslator;
    }
    return this._translators[elementName as ElementTypes];
  }
}
